// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.bg-dark {
    background-color: #171717 !important;
}

.color-scheme__modal {
    background-color: #242424 !important;
    color: whitesmoke !important;
}

.modal-content {
    background-color: #232323 !important;
}

.modal-title {
    color: white !important;
}

.modal-content .modal-body p {
    color: white !important;
}
.custom-context-menu {
    background-color: #171717 !important;
}

.custom-context-menu > li {
    color: white !important;
}

.custom-context-menu > li > .disable-action {
    color: white !important;
}

.custom-context-menu > li:hover {
    color: #171717 !important;
}

.custom-context-menu > li > .disable-action:hover {
    color: #171717 !important;
}

.deleteTemplate_btn {
    color: #171717;
}

.modal-header + .innerForm .form-group label {
    color: white !important;
}

.modal-header + .innerForm .form-group input:not([type="checkbox"]),
.innerForm .form-group select {
    color: white !important;
}

.userCard .card-body .card-title span i.edit {
    height: 32px !important;
}

.userCard:hover {
    transform: scale(1.05);
}

.controls i.fa-microphone,
.controls i.fa-microphone-slash,
.controls i.fa-play,
.controls i.fa-spinner {
  cursor: pointer;
  font-size: 18px;
  color: #fff;
}

.controls i.fa-microphone.selected-mode,
.controls i.fa-microphone-slash.selected-mode {
  color: #ff4444;
}

.controls i.fa-spinner {
  color: #3498db;
}

.controls i.fa-play {
  color: #fff
}

.controls i:hover {
  color: rgb(255, 102, 0);
}
`, "",{"version":3,"sources":["webpack://./src/modules/private/components/custom.css"],"names":[],"mappings":"AAAA;IACI,oCAAoC;AACxC;;AAEA;IACI,oCAAoC;IACpC,4BAA4B;AAChC;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,uBAAuB;AAC3B;AACA;IACI,oCAAoC;AACxC;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;;IAEI,uBAAuB;AAC3B;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;;;;EAIE,eAAe;EACf,eAAe;EACf,WAAW;AACb;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE;AACF;;AAEA;EACE,uBAAuB;AACzB","sourcesContent":[".bg-dark {\n    background-color: #171717 !important;\n}\n\n.color-scheme__modal {\n    background-color: #242424 !important;\n    color: whitesmoke !important;\n}\n\n.modal-content {\n    background-color: #232323 !important;\n}\n\n.modal-title {\n    color: white !important;\n}\n\n.modal-content .modal-body p {\n    color: white !important;\n}\n.custom-context-menu {\n    background-color: #171717 !important;\n}\n\n.custom-context-menu > li {\n    color: white !important;\n}\n\n.custom-context-menu > li > .disable-action {\n    color: white !important;\n}\n\n.custom-context-menu > li:hover {\n    color: #171717 !important;\n}\n\n.custom-context-menu > li > .disable-action:hover {\n    color: #171717 !important;\n}\n\n.deleteTemplate_btn {\n    color: #171717;\n}\n\n.modal-header + .innerForm .form-group label {\n    color: white !important;\n}\n\n.modal-header + .innerForm .form-group input:not([type=\"checkbox\"]),\n.innerForm .form-group select {\n    color: white !important;\n}\n\n.userCard .card-body .card-title span i.edit {\n    height: 32px !important;\n}\n\n.userCard:hover {\n    transform: scale(1.05);\n}\n\n.controls i.fa-microphone,\n.controls i.fa-microphone-slash,\n.controls i.fa-play,\n.controls i.fa-spinner {\n  cursor: pointer;\n  font-size: 18px;\n  color: #fff;\n}\n\n.controls i.fa-microphone.selected-mode,\n.controls i.fa-microphone-slash.selected-mode {\n  color: #ff4444;\n}\n\n.controls i.fa-spinner {\n  color: #3498db;\n}\n\n.controls i.fa-play {\n  color: #fff\n}\n\n.controls i:hover {\n  color: rgb(255, 102, 0);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
